import io from "socket.io-client";

const host = process.env.REACT_APP_SOCKET;

export default function () {
    return io.connect(host, {transports: ['websocket']})
}
